module.exports = __webpack_public_path__ + "static/media/VITHAL-SHESHAYYA.4fe3f6d1.png";